import { useAuth } from "@onefront/react-sdk";

type UserInformationsDto = {
    firstName: string;
    lastName: string;
    email: string;
};

const useGetUserInfo = (): UserInformationsDto | null => {
    const { loading, error, tokenData } = useAuth();

    if (loading === true || error !== null || !tokenData) {
        return null;
    }

    return {
        firstName: tokenData.given_name,
        lastName: tokenData.family_name,
        email: tokenData.email,
    };
};

export default useGetUserInfo;
